import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Box,
  Button,
  Typography,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  InputAdornment
} from "@mui/material";
import {withStyles, makeStyles} from "@mui/styles";
import ASPECStyles from "../../../../styles/jss/components/apps/ASPECStyles";
import * as _ from 'lodash';
import LoadcasesTable from "./LoadcasesTable";
import LoadsTable from "./LoadsTable";

// Icon Imports
import WarningIcon from "@mui/icons-material/Warning";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { pink } from '@mui/material/colors';

const useStyles = makeStyles(ASPECStyles);

function isBlank(str) {
  return /^\s*$/.test(str); // test for blank string
}

const LoadcaseSection = (props) => {

  const classes = useStyles();
  const [itter, setItter] = React.useState(1);
  const [loading, setLoading] = React.useState(true);
  const [formData, setFormData] = React.useState([]);
  const [selectedLoads, setSelectedLoads] = React.useState([]); // to setlect and delete multiple rows
  const [error, setError] = React.useState([]);

  const tableUnlocked = props.status !== "SUCCESSFUL";

  // Update input variants when missionMix is changed.
  React.useEffect(  () => {
    setFormData(props.data);
    setLoading(false);
    setItter(i => i + 1);
    return function cleanup() {
      setFormData([]);
    }
  }, [props.data])

  const StyledGrid = withStyles((theme) => ({
    root: {
      '&&& .hideScrollbar::-webkit-scrollbar': {
        background: 'transparent' /* Chrome/Safari/Webkit */,
        width: 0,
      },
    },
  }))(Grid);

  const isFieldDisabled = () => {
    return !tableUnlocked || props.isRunning || props.isSaving
  }

  const addRow = () => {
    props.addAppliedLoad();
  }

  const deleteRows = () => {
    props.deleteAppliedLoads(selectedLoads)
    setSelectedLoads([]); // reset selected rows
  }

  const getDeleteButtonText = () => {
    const length = selectedLoads.length;
    if (length === 1) {
      return 'Delete 1 Load';
    } else if (length > 1) {
      return 'Delete ' + length + ' Loads';
    }
    return 'Delete Load(s)';
  }

  const getValue = (loadcase, column, section='') => {
    // if (section === 'inboard') {
    //   return loadcase.inboard[column];
    // } else if (section === 'outboard') {
    //   return loadcase.outboard[column];
    // } else {
    if (loadcase) {
      return loadcase[column];
    }
    return null;
  };

  const getField = (loadcase, column, cbIdx, label=column, section='', unit='') => {
    const value = getValue(loadcase, column, section)
    return (
      <TextField
        name={column}
        label={label}
        fullWidth
        defaultValue={value}
        disabled={isFieldDisabled()}
        // value={value}
        error={value ? Boolean(value.error) : false}
        focused={value ? value.focus : false}
        type={'number'}
        variant="outlined"
        size="small"
        onBlur={(e) => handleTextfieldChange(e, cbIdx, column, section, props)}
        // onChange={(e) => handleTextfieldChange(e, cbIdx, column, section, props)}
        style={{margin: '16px 0px 0px 0px'}}
        slotProps={{
          input: unit ? {
            endAdornment:
            <InputAdornment position="end">
              <Typography variant={'caption'} style={{ color: "rgba(0,0,0,0.54)" }}>{unit}</Typography>
            </InputAdornment>
          } : {}
        }}
      />
    );
  };

  const getCheckboxField = (loadcase, column, cbIdx, section='', unit='') => {
    console.log(loadcase)
    const value = getValue(loadcase, column, section)
    console.log(value)
    return (
      <Checkbox
        color="primary"
        name={'args.calculate.shearCenter'}
        checked={value}
        onChange={e => handleTextfieldChange(e, cbIdx, column, section, props)}
        // disabled={status}
      />
    );

  };

  const handleTextfieldChange = async (e, cbIdx, column, section, props) => {
    console.log(column + "-" + e.target.value)
    // if (column === "index") {
    //   const newId = parseFloat(e.target.value);
    //   console.log(props.loadcaseIdAlreadyTaken(newId))
    //   if (props.loadcaseIdAlreadyTaken(newId)) {
    //     e.preventDefault();
    //     e.target.reset();
    //     return; // Skip update if loadcase ID already taken
    //   }
    // }
    console.log(`handleTextfieldChange: data.loadcases[${cbIdx}].${column}`)
    if (section !== '') {
      props.update(parseFloat(e.target.value), `data.loadcases[${cbIdx}].${section}.${column}`);
    } else {
      if (e.target.type === "checkbox") {
        props.update(e.target.checked, `data.loadcases[${cbIdx}].${column}`);
      } else {
        props.update(parseFloat(e.target.value), `data.loadcases[${cbIdx}].${column}`);
      }
    }

  };

  return(
    <div style={{height: "100%"}}>
        <Card style={{height: "100%", minHeight: "600px"}}>
          <CardHeader
            // title={'Stringers'}
            classes={{
              title: classes.cardHeaderTitle,
              root: classes.cardHeaderRoot,
              content: classes.cardHeaderContent,
              action: classes.cardHeaderAction
            }}
          />
          {props.selectedLoadcase ? (
            <StyledGrid container>
              <Grid size={{ md: 12 }} >
                <Box
                    className={useStyles.container}
                    borderBottom="1px solid #9E9E9E"
                    height={48}
                  >
                  <Typography variant="h5" style={{fontSize: '18px', padding: '5px 0 0 16px'}}>Loadcase {props.selectedLoadcaseIndex}</Typography>
                </Box>
              </Grid>
              <Grid container spacing={2} style={{fontSize: '20px', padding: '10px 16px 16px 16px'}}>
                <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
                  {getField(props.selectedLoadcase, 'index', props.loadcaseIdx, 'ID')}
                </Grid>
                <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
                  {getField(props.selectedLoadcase, 'appliedLoadPointCount', props.loadcaseIdx, 'Number of load points for applied loads')}
                </Grid>
              </Grid>
              <Grid size={{ md: 2 }}>
                <Box
                    className={useStyles.container}
                    borderBottom="1px solid #9E9E9E"
                    height={48}
                  >
                  <Typography variant="h4" style={{fontSize: '16px', padding: '8px 0 0 16px'}}>Applied Loads</Typography>
                </Box>
              </Grid>
              <Grid style={{flexGrow: "1"}}className={'root'} align="right">
                <Box
                  className={useStyles.container}
                  borderBottom="1px solid #9E9E9E"
                  height={48}
                >
                  <Button
                    disabled={isFieldDisabled()}
                    color={'primary'}
                    startIcon={<AddIcon />}
                    onClick={addRow}
                  >
                    Add Load
                  </Button>
                  <Button
                    disabled={isFieldDisabled() || selectedLoads.length === 0}
                    color={'primary'}
                    startIcon={<DeleteIcon />}
                    onClick={deleteRows}
                  >
                    {getDeleteButtonText()}
                  </Button>
                </Box>
              </Grid>
            </StyledGrid>
          ) : (
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
              sx={{ minHeight: '100vh' }}
              style={{ height: "655px"}}
            >
              <Grid size={{ xs: 3 }}>
                <Typography className={classes.inputErrorCardContent}><WarningIcon  sx={{ color: pink[500] }} /> Please select a loadcase.</Typography>
              </Grid>
            </Grid>
          )}
          <StyledGrid container style={props.selectedLoadcase ? {} : { display: 'none' }}>
            <Grid size={{ md: 12 }} >
              <Box
                className={useStyles.container}
              >
                <LoadsTable
                  data={formData}
                  status={props.status}
                  update={props.update}
                  selectedLoads={selectedLoads}
                  setSelectedLoads={setSelectedLoads}
                  selectedLoadcase={props.selectedLoadcase}
                  loadcaseIdx={props.loadcaseIdx}
                />
              </Box>
            </Grid>
          </StyledGrid>

        </Card>

      {error.length > 0 && (
        <div className={classes.errorRoot}>
          <div className={classes.errorContainer}>
            <p className={classes.errorText}>{error[error.length - 1].message}</p>
          </div>
        </div>
      )}

    </div>
  )
};

export default LoadcaseSection;